import { render } from "./DeviseRateEditor.vue?vue&type=template&id=77794ba2&scoped=true"
import script from "./DeviseRateEditor.vue?vue&type=script&lang=js"
export * from "./DeviseRateEditor.vue?vue&type=script&lang=js"

import "./DeviseRateEditor.vue?vue&type=style&index=0&id=77794ba2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77794ba2"]])

export default __exports__